<div class="filter-panel">
  <div class="filter-element">
    <!-- Dropdown for selecting a filter -->
    <select class="dropdown" [(ngModel)]="selectedFilter" (change)="onFilterChange($event)">
      <option value="" disabled selected>Choose Filter</option>
      <option *ngFor="let prop of filterProps" [value]="prop.field">{{ prop.label }}</option>
    </select>

    <!-- Dynamic field for filter input -->
    <div class="dynamic-input">
      <ng-container *ngIf="activeFilter && activeFilter.type === FilterType.TEXT">
        <input
          type="text"
          class="text-field"
          placeholder="{{activeFilter.multiple ? 'Enter values (supports multiple separated by comma)' : 'Enter value'}}"
          [(ngModel)]="inputValue"
        />
      </ng-container>
      <ng-container *ngIf="activeFilter && activeFilter.type === FilterType.SELECT">
        <select class="dropdown" [(ngModel)]="selectedOption">
          <option *ngFor="let option of activeFilter.options" [value]="option">
            {{ option }}
          </option>
        </select>
      </ng-container>
      <ng-container *ngIf="activeFilter && activeFilter.type === FilterType.DATE">
        <input
          type="date"
          class="date-field"
          [(ngModel)]="selectedDate"
        />
      </ng-container>
    </div>

    <!-- Button to add the filter -->
    <button class="action-button" (click)="addFilter()">Add Filter</button>
  </div>

  <!-- Chips to display selected filters -->
  <div class="chip-container">
    <ng-container *ngFor="let key of filterKeys">
      <ng-container *ngFor="let value of getFilterValues(key)">
        <div class="chip">
          {{ key }}: {{ value }}
          <span class="close-btn" (click)="removeFilter(key, value)">×</span>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
